module.exports = {"420303001":"花果街道","420303002":"红卫街道","420303003":"车城路街道","420303004":"汉江路街道","420303100":"黄龙镇","420303101":"柏林镇","420303200":"方滩乡","420303201":"西沟乡","420303400":"西城开发区","420303401":"十堰工业新区","420303500":"秦家坪林场","420303501":"凤凰山茶场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420303.json
// module id = 1569
// module chunks = 0